import { MdWhatshot, MdPersonAdd, MdTimer, MdVerifiedUser } from "react-icons/md";
import { IoTrailSign } from "react-icons/io5";
import { GiArmorUpgrade } from "react-icons/gi";
import { AiFillHeart } from "react-icons/ai";

export const allWorkouts = [
  {
    id: 1,
    name: "allWorkouts",
    title: "Getätigte Übungen",
    description:
      "Mache Übungen an den Stationen. Es zählen verifizierte und unverifizierte Workouts.",
    longDescription:
      "Du warst vor Ort, hast aber vergessen den QR-Code zu scannen? Das ist kein Problem. Dieses Abzeichen bekommst du auch für Workouts, die nicht verifiziert sind.",
    icon: GiArmorUpgrade,
    color: "#b70000",
    badgeType: "gesamt",
  },
  { id: 11, amount: 1, unit: "Übung" },
  { id: 12, amount: 3, unit: "Übungen" },
  { id: 13, amount: 5, unit: "Übungen" },
  { id: 15, amount: 10, unit: "Übungen" },
  { id: 16, amount: 15, unit: "Übungen" },
  { id: 17, amount: 20, unit: "Übungen" },
  { id: 18, amount: 30, unit: "Übungen" },
  { id: 19, amount: 50, unit: "Übungen" },
  { id: 110, amount: 70, unit: "Übungen" },
  { id: 111, amount: 100, unit: "Übungen" },
  { id: 112, amount: 200, unit: "Übungen" },
];

export const verifiedWorkouts = [
  {
    id: 2,
    name: "verifiedWorkouts",
    title: "Verifizierte Übungen",
    description:
      "Mache Übungen an den Stationen und verifiziere diese durch das Scannen des QR-Codes.",
    longDescription:
      "Das Verifizieren der Übungen soll verhindern, dass bei dem Loggen des Sports geflunkert wird. Scanne die QR-Codes an den Stationen, um zu zeigen, dass du vor Ort warst.",
    icon: MdVerifiedUser,
    color: "#b70000",
    badgeType: "verifiziert",
  },
  { id: 21, amount: 1, unit: "Übung" },
  { id: 22, amount: 3, unit: "Übungen" },
  { id: 23, amount: 5, unit: "Übungen" },
  { id: 25, amount: 10, unit: "Übungen" },
  { id: 26, amount: 15, unit: "Übungen" },
  { id: 27, amount: 20, unit: "Übungen" },
  { id: 28, amount: 30, unit: "Übungen" },
  { id: 29, amount: 50, unit: "Übungen" },
  { id: 210, amount: 70, unit: "Übungen" },
  { id: 211, amount: 100, unit: "Übungen" },
  { id: 212, amount: 200, unit: "Übungen" },
];

export const sumTime = [
  {
    id: 3,
    name: "sumTime",
    title: "Zeit im Workout",
    description: "Trainiere für eine bestimmte Zeit in einer beliebigen Übung.",
    longDescription:
      "Ausdauer wird belohnt. Dieses Abzeichen erhältst du, wenn du die entsprechende Zeit mit einer Übung aktiv warst.",
    icon: MdTimer,
    color: "#b400b7",
    badgeType: "Workoutdauer",
  },
  { id: 31, amount: 2, unit: "min", min: 2 },
  { id: 32, amount: 5, unit: "min", min: 5 },
  { id: 33, amount: 10, unit: "min", min: 10 },
  { id: 34, amount: 15, unit: "min", min: 15 },
  { id: 35, amount: 30, unit: "min", min: 30 },
  { id: 36, amount: 45, unit: "min", min: 45 },
  { id: 37, amount: 60, unit: "min", min: 60 },
  { id: 38, amount: 2, unit: "h", min: 120 },
  { id: 39, amount: 3, unit: "h", min: 180 },
  { id: 310, amount: 4, unit: "h", min: 240 },
  { id: 311, amount: 5, unit: "h", min: 300 },
  { id: 312, amount: 10, unit: "h", min: 600 },
  { id: 313, amount: 20, unit: "h", min: 1200 },
  { id: 314, amount: 30, unit: "h", min: 1800 },
];

export const streak = [
  {
    id: 4,
    name: "streak",
    title: "Streaks",
    description: "Trainiere mehrere Tage in Folge und erhalte eine Streak.",
    longDescription:
      "Streak Badges zeigen deine Motivation, regelmäßig Sport zu machen. Solltest du mehrere Tage in Folge den Fitness Trail besuchen, bekommst du dieses Abzeichen.",
    icon: MdWhatshot,
    color: "#b74600",
    badgeType: "Streak",
  },
  { id: 41, amount: 2, unit: "Tage", days: 2 },
  { id: 42, amount: 5, unit: "Tage", days: 5 },
  { id: 43, amount: 7, unit: "Tage", days: 7 },
  { id: 44, amount: 14, unit: "Tage", days: 14 },
  { id: 45, amount: 3, unit: "Wochen", days: 21 },
  { id: 46, amount: 4, unit: "Wochen", days: 28 },
  { id: 47, amount: 10, unit: "Wochen", days: 70 },
  { id: 48, amount: 20, unit: "Wochen", days: 140 },
  { id: 49, amount: 30, unit: "Wochen", days: 210 },
  { id: 410, amount: 40, unit: "Wochen", days: 280 },
  { id: 411, amount: 1, unit: "Jahr", days: 365 },
];

export const allStations = [
  {
    id: 5,
    name: "completedTrail",
    title: "Vollständiger Trail",
    description: "Trainiere an einem Tag an allen Stationen des Trails.",
    longDescription:
      "Der Trail ist nicht nur vielfältig, sondern auch lang. Solltest du den gesamten Trail mehrmals vollständig absolvieren, wirst du für deine Ausdauer belohnt.",
    icon: IoTrailSign,
    color: "#00b71b",
    badgeType: "Trail",
  },
  { id: 51, amount: 1, unit: "Mal" },
  { id: 52, amount: 3, unit: "Mal" },
  { id: 53, amount: 5, unit: "Mal" },
  { id: 54, amount: 10, unit: "Mal" },
  { id: 55, amount: 15, unit: "Mal" },
  { id: 56, amount: 20, unit: "Mal" },
  { id: 57, amount: 30, unit: "Mal" },
  { id: 58, amount: 50, unit: "Mal" },
  { id: 59, amount: 70, unit: "Mal" },
  { id: 510, amount: 100, unit: "Mal" },
  { id: 511, amount: 200, unit: "Mal" },
];

export const followings = [
  {
    id: 6,
    name: "followings",
    title: "Freundeskreis",
    description: "Vernetze dich mit deinen Freunden, um euch gegenseitig zu motivieren.",
    longDescription:
      "Freunde sind etwas Schönes. Sie können dabei helfen, motiviert zu bleiben. Verbinde dich in der App mit deinen Freunden und erhalte eine Auszeichnung.",
    icon: MdPersonAdd,
    color: "#003db7",
    badgeType: "Freundeskreis",
  },
  { id: 61, amount: 1, unit: "Freund" },
  { id: 62, amount: 2, unit: "Freunde" },
  { id: 63, amount: 5, unit: "Freunde" },
  { id: 64, amount: 10, unit: "Freunde" },
  { id: 65, amount: 15, unit: "Freunde" },
  { id: 66, amount: 20, unit: "Freunde" },
  { id: 67, amount: 30, unit: "Freunde" },
];

export const likes = [
  {
    id: 7,
    name: "likes",
    title: "Motivation",
    description: "Gib deinen Freunden Likes, um sie zu motivieren.",
    longDescription:
      "Like die Workouts deiner Freunde. Sie freuen sich bestimmt und bleiben motiviert. Erhalte diesen Erfolg für deine Likes im Feed.",
    icon: AiFillHeart,
    color: "#003db7",
    badgeType: "Motivation",
  },
  { id: 71, amount: 1, unit: "Like" },
  { id: 72, amount: 5, unit: "Likes" },
  { id: 73, amount: 10, unit: "Likes" },
  { id: 74, amount: 25, unit: "Likes" },
  { id: 75, amount: 50, unit: "Likes" },
  { id: 76, amount: 70, unit: "Likes" },
  { id: 77, amount: 100, unit: "Likes" },
];

export const allBadges = [
  ...streak,
  ...allStations,
  ...followings,
  ...likes,
  ...verifiedWorkouts,
  ...allWorkouts,
  ...sumTime,
];

export function getBadgeDetails(ID) {
  return allBadges.find((el) => el.id === Number(ID.toString().charAt(0)));
}
